import { useLocation, useNavigate } from 'react-router-dom'
import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'

import { useCreatePolicyMutation } from '@/core/services/policy'

import { getApiErrorMessage } from '@/utils/errors'

import PolicyForm from '../components/PolicyForm'

export default function CreatePolicyForm() {
  const location = useLocation()
  const navigate = useNavigate()
  const { enqueueSnackbar } = useSnackbar()
  const { t } = useTranslation()

  const [createPolicy, { isLoading: isCreatingPolicy }] = useCreatePolicyMutation()

  return (
    <PolicyForm
      isSubmitting={isCreatingPolicy}
      onSubmit={async (values) => {
        try {
          await createPolicy(values).unwrap()
          navigate(location.pathname.replace('/create', ''))
        } catch (error) {
          enqueueSnackbar(getApiErrorMessage(error, t('notification.policy.create.error')), { variant: 'error' })
        }
      }}
    />
  )
}
